export const API_GET_ALL_PREREGISTER_QRCODE = "API_GET_ALL_PREREGISTER_QRCODE";
export const API_GET_ALL_PREREGISTER_QRCODE_SUCCESS = "API_GET_ALL_PREREGISTER_QRCODE_SUCCESS";
export const API_GET_ALL_PREREGISTER_QRCODE_FAIL = "API_GET_ALL_PREREGISTER_QRCODE_FAIL";

export const SET_QR_PREREGISTER = "SET_QR_PREREGISTER";

export const API_GET_PREREGISTER_APPOINTMENT = "API_GET_PREREGISTER_APPOINTMENT";
export const API_GET_PREREGISTER_APPOINTMENT_FORCE_STATUS = "API_GET_PREREGISTER_APPOINTMENT_FORCE_STATUS";
export const API_GET_PREREGISTER_APPOINTMENT_SUCCESS = "API_GET_PREREGISTER_APPOINTMENT_SUCCESS";
export const API_GET_PREREGISTER_APPOINTMENT_FAIL = "API_GET_PREREGISTER_APPOINTMENT_FAIL";
export const API_GET_RECALLS_PREREGISTER = "API_GET_RECALLS_PREREGISTER";
export const API_GET_RECALLS_PREREGISTER_SUCCESS = "API_GET_RECALLS_PREREGISTER_SUCCESS";
export const API_GET_RECALLS_PREREGISTER_FAIL = "API_GET_RECALLS_PREREGISTER_FAIL";

export const API_EXPORT_PREREGISTERS = "API_EXPORT_PREREGISTERS";
export const API_GET_PREREGISTERS_LIST = "API_GET_PREREGISTERS_LIST";
export const API_GET_PREREGISTERS_LIST_SUCCESS = "API_GET_PREREGISTERS_LIST_SUCCESS";
export const API_GET_PREREGISTERS_LIST_FAIL = "API_GET_PREREGISTERS_LIST_FAIL";

export const API_PATCH_PREREGISTER_REMINDER = "API_PATCH_PREREGISTER_REMINDER";

export const API_PATCH_PREREGISTER_WAITING_FLAG = "API_PATCH_PREREGISTER_WAITING_FLAG";
export const API_PATCH_PREREGISTER_WAITING_FLAG_SUCCESS = "API_PATCH_PREREGISTER_WAITING_FLAG_SUCCESS";
export const API_PATCH_PREREGISTER_WAITING_FLAG_FAIL = "API_PATCH_PREREGISTER_WAITING_FLAG_FAIL";

export const API_POST_CHECKIN = "API_POST_CHECKIN";
export const API_POST_CHECKIN_SUCCESS = "API_POST_CHECKIN_SUCCESS";
export const API_POST_CHECKIN_FAIL = "API_POST_CHECKIN_FAIL";

export const API_GET_CHECKIN = "API_GET_CHECKIN";
export const API_GET_CHECKIN_SUCCESS = "API_GET_CHECKIN_SUCCESS";
export const API_GET_CHECKIN_FAIL = "API_GET_CHECKIN_FAIL";
